module.exports = __webpack_public_path__ + "img/10.c8bb37b4.webp";